import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterLinkViewerModels } from '@medsurf/flat-models';
import { PageSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-pages',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: false
})
export class PagesComponent {
  /**
   * TODO move to route data
   * Members
   */
  public footerLinks: FooterLinkViewerModels.FooterLink[] = [
    {title: 'DATENSCHUTZERKLÄRUNG', url: 'privacy'},
    {title: 'IMPRESSUM', url: 'impressum'}
  ];

  /**
   * Constructor
   *
   * @param pageSharedFacade
   */
  public constructor(public pageSharedFacade: PageSharedFacade) {
  }
}
